export default function ($routeSegmentProvider) {

  "ngInject";

  $routeSegmentProvider
    .when('/admin/notifications', 'admin.notifications')

    .within('admin')

    .segment('notifications', {
      access: {requireLogin: true, hasAuthority: 'ADMIN'},
      breadcrumb: [{
        label: 'admin.breadcrumb.notifications'
      }],
      template: '<admin-notifications-list-page></admin-notifications-list-page>',
      loadModule: () => {
        return import(/* webpackChunkName: "admin-notifications-list.module" */ "./list/admin-notifications-list.module");
      }
    })
}
